/* eslint-disable react/no-array-index-key */
/* eslint-disable no-irregular-whitespace */
import React, { useCallback, useEffect, useState } from "react";
import { CARGO_CODES } from "constants/permissions";
import { Carousel } from "components/CarouselG";
import ModalNotifications from "screens/home/components/modalNotifications";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { IoPeopleOutline, IoStorefrontOutline } from "react-icons/io5";
import { MdOutlineSms } from "react-icons/md";
import { RiHotelLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { Skeleton } from "@mui/material";
import { debounce } from "screens/perfilAutonomo/utils";
import { getAutonomoSimplified } from "screens/perfilAutonomo/api/getAutonomo";
import * as S from "./styles";
import axiosLead from "../../../../services/lead";
import * as IconsSVG from "../../../../assets/iconsSVG";
import { postListarBannerUsuarioLogado } from "./postListarBannerUsuarioLogado";

const slide = [
  {
    image:
      "https://appvendasstorageprod.blob.core.windows.net/banner-home/image.png",
    href: "https://appvendasstorageprod.blob.core.windows.net/banner-home/CARTILHALGPD.pdf",
  },
];

function CarouselContent() {
  const {
    name,
    username,
    usuarioCia,
    codigoCargo2013,
    codigoEmpresaVendas365,
    codigoRegional365,
    permissoes,
  } = useSelector<RootStateOrAny, AuthState>((state) => state.user);
  const [carouselContent, setCarouselContent] = useState<
    { image: string; href: string }[]
  >([]);
  const [loadingCarouselContent, setLoadingCarouselContent] = useState(false);

  // inicializando conteúdo do banner
  useEffect(() => {
    setLoadingCarouselContent(true);

    getAutonomoSimplified(username)
      .then((res) => {
        const tempToken = res?.userAdResponse?.token || "";

        if (res) retrieveBanners(tempToken);
        else throw new Error();
      })
      .catch(() => {
        retrieveBanners(null); // sem token nesse caso
      });
  }, []);

  const retrieveBanners = useCallback(
    debounce((authToken) => {
      postListarBannerUsuarioLogado({
        codigoRegional365: codigoRegional365 || "",
        codigoEmpresaVendas365: codigoEmpresaVendas365 || "",
        authToken: authToken || "" || undefined,
      })
        .then(({ success, data, notifications }) => {
          if (success) {
            const content = data?.map((item: any) => ({
              image: item?.imagem?.url,
              href: item?.link,
            }));
            setCarouselContent(content);
          } else throw new Error(notifications?.[0]?.message);
        })
        .catch((error) => {
          console.error(error);
          setCarouselContent(slide); // fallback
        })
        .finally(() => setLoadingCarouselContent(false));
    }, 250),
    [codigoRegional365, codigoEmpresaVendas365]
  );

  const isGerenteComercial = codigoCargo2013 === CARGO_CODES.GERENTE_COMERCIAL;
  const isSupervisorProduto = codigoCargo2013 === CARGO_CODES.SUPERVISOR;
  const isCoordenadorProduto =
    codigoCargo2013 === CARGO_CODES.COORDENADOR_PRODUTO;
  const isUsuarioCia = usuarioCia;
  const isGerenteCia = codigoCargo2013 === CARGO_CODES.GERENTE_CIA;

  // Regras de visualização por tipo de usuário
  const getVisibleRoutes = () => {
    const routesForGeneral = [
      {
        name: "Leads",
        icon: <IoPeopleOutline color="#2D5BFF" size={20} />,
        href: "/leads-infos",
        target: "_self",
      },
      {
        name: "Mobi",
        icon: <MdOutlineSms color="#2D5BFF" size={20} />,
        href: "https://cbr.mobicrm.com.br/login",
        target: "_blank",
      },
      {
        name: "Produtos",
        icon: <IconsSVG.ProductPredio2 color="#2D5BFF" />,
        href: "/produtos",
        target: "_self",
      },
    ];

    const routesForRevenda = [
      {
        name: "Produtos",
        icon: <IconsSVG.ProductPredio2 color="#2D5BFF" />,
        href: "/produtos",
        target: "_self",
      },
      {
        name: "Revenda",
        icon: <RiHotelLine color="#2D5BFF" />,
        href: "/revenda",
        target: "_self",
      },
    ];

    const routesForCia = [
      ...(isGerenteCia
        ? []
        : [
            {
              name: "Novo Lead",
              icon: <IoPeopleOutline color="#2D5BFF" size={20} />,
              href: "/leads-novo",
              target: "_self",
            },
          ]),
      {
        name: "Funil de Propostas",
        icon: <IconsSVG.FunilPropostasIcon color="#2D5BFF" />,
        href: "/funil-de-propostas",
        target: "_self",
      },
      {
        name: "Produtos",
        icon: <IconsSVG.ProductPredio2 color="#2D5BFF" />,
        href: "/produtos",
        target: "_self",
      },
    ];

    const routesForGerenteComercial = [
      {
        name: "Funil Comercial",
        icon: <IconsSVG.FunilPropostasIcon color="#2D5BFF" />,
        href: "/funil-comercial",
        target: "_self",
      },
      {
        name: "Funil de Propostas",
        icon: <IconsSVG.FunilPropostasIcon color="#2D5BFF" />,
        href: "/funil-de-propostas",
        target: "_self",
      },
      {
        name: "Produtos",
        icon: <IconsSVG.ProductPredio2 color="#2D5BFF" />,
        href: "/produtos",
        target: "_self",
      },
    ];

    const routesForSupervisorProduto = [
      {
        name: "PDV",
        icon: <IoStorefrontOutline color="#2D5BFF" />,
        href: "/plantao",
        target: "_self",
      },
      {
        name: "Funil de Propostas",
        icon: <IconsSVG.FunilPropostasIcon color="#2D5BFF" />,
        href: "/funil-de-propostas",
        target: "_self",
      },
      {
        name: "Produtos",
        icon: <IconsSVG.ProductPredio2 color="#2D5BFF" />,
        href: "/produtos",
        target: "_self",
      },
    ];

    const routesForCoordenadorProduto = [
      {
        name: "Funil de Propostas",
        icon: <IconsSVG.FunilPropostasIcon color="#2D5BFF" />,
        href: "/funil-de-propostas",
        target: "_self",
      },
      {
        name: "Produtos",
        icon: <IconsSVG.ProductPredio2 color="#2D5BFF" />,
        href: "/produtos",
        target: "_self",
      },
    ];

    if (
      permissoes?.includes("conexao_revenda_esconder") &&
      permissoes?.includes("conexao_revenda")
    ) {
      return routesForRevenda;
    }

    if (isUsuarioCia) {
      return routesForCia;
    }

    if (isGerenteComercial) {
      return routesForGerenteComercial;
    }

    if (isSupervisorProduto) {
      return routesForSupervisorProduto;
    }

    if (isCoordenadorProduto) {
      return routesForCoordenadorProduto;
    }

    return routesForGeneral;
  };

  const visibleRoutes = getVisibleRoutes();

  const [notificationCount, setNotificationCount] = useState<number>(0);
  const [modalNotifications, setModalNotifications] = useState<boolean>(false);
  const [cards, setCards] = useState<any>([]);
  const [cardsReaded, setCardsReaded] = useState<any>([]);
  const [totalItensRetorno, setTotalItensRetorno] = useState<number>(10);
  const [loadingNotifications, setLoadingNotifications] =
    useState<boolean>(false);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);

  useEffect(() => {
    requestNotifications();
  }, [totalItensRetorno, modalNotifications]);

  const requestNotifications = async () => {
    setLoadingNotifications(true);
    const params = {
      TotalItensRetorno: totalItensRetorno,
      AtualizaNotificacaoLida: modalNotifications,
    };
    try {
      const response = await axiosLead.GetNotifications(params);
      setCardsReaded(response?.data?.data[0]?.notificacoesVisualizadas);
      setCards(response?.data?.data[0]?.notificacoesNaoVisualizadas);
      setNotificationCount(
        response?.data?.data[0]?.quantidadeNotificacoesNaoVisualizadas
      );
    } catch (error) {
      console.error(error);
    }
    setLoadingNotifications(false);
  };

  return (
    <>
      <S.Header>
        <S.WelcomeTitle>
          <p style={{ color: "#1A49CC" }}>Olá</p>, {name}
          <p style={{ color: "#1A49CC" }}>!</p>
        </S.WelcomeTitle>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              background: "#fff",
              borderRadius: "18px",
              margin: "8px 16px",
            }}
          >
            {visibleRoutes.map((route, index) => (
              <S.Card key={index} href={route.href} target={route.target}>
                {route.icon}
                <S.TextCard>{route.name}</S.TextCard>
              </S.Card>
            ))}
          </div>
          <S.SpaceX space={32} />

          <S.NotificationWrapper>
            {notificationCount > 0 && (
              <S.NotificationBadge>{notificationCount}</S.NotificationBadge>
            )}
            <S.UserAvatar
              onClick={() => setModalNotifications(!modalNotifications)}
            >
              <IconsSVG.NotificationIcon />
            </S.UserAvatar>
          </S.NotificationWrapper>
        </div>
        {/* Cabeçalho: "Olá, Ayrton!" + Badge de notificação */}
      </S.Header>
      {/* Carousel totalmente em styled-components */}
      {loadingCarouselContent ? (
        <Skeleton variant="rounded" height={300} width="100%" />
      ) : (
        <Carousel slides={carouselContent} />
      )}

      <ModalNotifications
        top="10"
        className={`open-${modalNotifications}`}
        setModalNotifications={setModalNotifications}
        cards={cards}
        cardsReaded={cardsReaded}
        setTotalItensRetorno={setTotalItensRetorno}
        totalItensRetorno={totalItensRetorno}
        loading={loadingNotifications}
        firstLoad={firstLoad}
        setFirstLoad={setFirstLoad}
      />
    </>
  );
}

export default CarouselContent;
